import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import PageTemplate from '../../../components/template/PageTemplate';
import RecommendReviewSaveContainer from '../../../containers/recommend/review/RecommendReviewSaveContainer';
import { recommendReviewActions } from '../../../store/modules/recommend/review';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import {
  RECOMMEND_REVIEW_ITEM_LIST_FILTER_OPTION_MODEL,
  RECOMMEND_REVIEW_ITEM_LIST_SORT_OPTION_MODEL,
  RECOMMEND_REVIEW_SAVE_MODEL,
} from '../../../store/modules/recommend/review/models';
import { RECOMMEND_REVIEW_PAGE_NAME } from '../../../constants/service/app/recommendReviewConstants';

class RecommendReviewCopy extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   *  초기화
   */
  componentWillUnmount() {
    const { setData } = this.props;

    setData({
      path: ['recommendReviewSave'],
      value: RECOMMEND_REVIEW_SAVE_MODEL,
    });
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (recommendReviewId) => {
    const { prepareCopyRecommendReview } = this.props;

    prepareCopyRecommendReview({
      recommendReviewId,
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_REVIEW_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       *  정렬 옵션
       */
      sortOption: RECOMMEND_REVIEW_ITEM_LIST_SORT_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  render() {
    return (
      <PageTemplate pageName={RECOMMEND_REVIEW_PAGE_NAME.RECOMMEND_REVIEW_COPY}>
        <RecommendReviewSaveContainer typeDisabled={true} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  setData: recommendReviewActions.setData,
  prepareCopyRecommendReview: recommendReviewActions.prepareCopyRecommendReview,
};

export default connect(null, mapDispatchToProps)(withRouter(RecommendReviewCopy));
